import React from "react";
import styled from "styled-components";
import { DOLink } from "../DOLink";

const textColor = "#031b4e";

const ErrorContainer = styled.div`
  margin: 0 auto;
  max-width: 900px;
  text-align: center;
  padding: 120px 16px;
`;

const ErrorTitle = styled.h1`
  font-size: 2.4rem;
  line-height: 1.25;
  color: ${textColor};
  font-weight: 800;
`;

const ErrorDescription = styled.p`
  font-size: 20px;
  margin-top: 16px;
  color: ${textColor};
`;

type Props = {
  statusCode?: number;
};

function Render400() {
  return (
    <>
      <ErrorTitle>Oh no! We couldn't find the page you were looking for.</ErrorTitle>
      <ErrorDescription>
        Have questions? Head over to our <DOLink docs={true} />, or try our robust <DOLink community={true} /> for answers and tutorials. Or
        go back to the <a href="/">homepage</a>.
      </ErrorDescription>
    </>
  );
}

function Render500() {
  return (
    <>
      <ErrorTitle>Looks like something went wrong...</ErrorTitle>
      <ErrorDescription>
        If this keeps happening, check out <DOLink status={true} />
      </ErrorDescription>
    </>
  );
}

export const ErrorState: React.FC<Props> = (props) => {
  return <ErrorContainer>{!props.statusCode || props.statusCode >= 500 ? Render500() : Render400()}</ErrorContainer>;
};
